<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index">
        {{ item.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: ['matched'],
  data() {
    return {
      breadcrumb: [],
    }
  },
  mounted() {
    this.$watch(() => this.matched, this.getRoute, { immediate: true })
  },
  methods: {
    getRoute() {
      for (var i = 0; i < this.matched.length; i++) {
        this.breadcrumb.push({
          path: this.matched[i].path,
          title: this.matched[i].meta.title,
        })
      }
    },
  },
}
</script>

<style></style>
